export default __webpack_public_path__ + "static/media/logo.df59c786.svg";